const MAX_HEIGHT = '18px';

export const MuiFormControlLabel = {
  defaultProps: {
    labelPlacement: 'top',
  },
  styleOverrides: {
    root: {
      marginLeft: 0,
      marginRight: 0,
      position: 'relative',

      '&:has(.Mui-focused) .MuiFormControlLabel-label': {
        color: '#1010EB',
      },
      '& div': {
        display: 'flex', // to keep asterisk and custom label on the same line
      },
      '& .MuiStack-root': {
        display: 'flex',
        gap: 2,
      },
    },
    label: {
      maxHeight: MAX_HEIGHT,
      fontSize: '1.4rem',

      '&.Mui-disabled': {
        color: '#170F5F',
      },
    },
    labelPlacementTop: {
      alignItems: 'flex-start',
      mx: 0,
      width: '100%',

      '& .MuiFormControlLabel-label': {
        color: '#170F5F',
      },
    },
    asterisk: {
      color: '#871C80',
      maxHeight: MAX_HEIGHT,
      marginRight: 3,
      order: -1,
    },
  },
};
